import { createRouter, createWebHistory } from 'vue-router';
import { MotionPlugin } from '@vueuse/motion';
import YandexMetrika from '@/yandex-metrika';
import { createApp } from 'vue';

import '@albank/vue-ui-kit/style.css';
import './style.scss';

import NotFound from '@/pages/NotFound.vue';
import Home from '@/pages/HomePage.vue';
import App from '@/App.vue';

const PrivacyPolicy = () => import('./pages/PrivacyPolicy.vue');

const app = createApp(App);

app.use(MotionPlugin);

app.use(YandexMetrika);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { name: 'home', path: '/', component: Home },
    {
      name: 'privacy-policy',
      path: '/privacy-policy',
      component: PrivacyPolicy
    },
    { path: '/:pathMatch(.*)*', component: NotFound }
  ]
});

app.use(router);

app.mount('#app');
